import PropTypes from "prop-types";
import React from "react";
import {first, isArray} from "lodash";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
const MSelectField = props => {
  const { input, containerClassName, menuItems, itemLabel, itemValue, ...rest } = props;
  const isInvalidate = rest.meta && rest.meta.touched && rest.meta.error && !!rest.meta.error.length;
  const errorMessage = isInvalidate
    ? (isArray(rest.meta.error) ? first(rest.meta.error) : rest.meta.error)
    : "";

  delete rest.meta;
  delete rest.input;
  delete rest.containerClassName;

  // Render menu items from array
  const renderMenuItems = () => {
    if (!menuItems || !Array.isArray(menuItems)) return null;
    return menuItems.map((item, index) => {
      if (typeof item === "object") {
        const value = item[itemValue] != null ? item[itemValue] : item[itemLabel];
        const label = item[itemLabel];
        return <MenuItem key={index} value={value}>{label}</MenuItem>;
      }
      // Primitive value
      return <MenuItem key={index} value={item}>{item}</MenuItem>;
    });
  };

  return (
    <TextField
      select
      variant="standard"
      {...rest}
      className={containerClassName}
      value={input.value}
      onChange={(e) => input.onChange(e.target.value)}
      data-test={rest.dataTest}
      error={isInvalidate}
      helperText={isInvalidate ? errorMessage : undefined}
    >
      {renderMenuItems()}
    </TextField>
  );
};

MSelectField.propTypes = {
  input: PropTypes.object.isRequired,
  containerClassName: PropTypes.string,
  menuItems: PropTypes.array,
  itemValue: PropTypes.string,
  itemLabel: PropTypes.string
};
export default MSelectField;

